<title>Autoverkoop Partner - Fout</title>

<!-- Page Content -->
<div class="container">
  <div class="card border-0 shadow my-5">
    <div class="card-body p-5">
      <img class="img-fluid header-img" src="/assets/images/avp-logo.png">
      <hr>
        <h1 class="font-weight-light">Oeps!</h1>
        <div>
          @switch (errorType) {
            @case ('general') {
              <div>
                <p class="lead">Er is een algemene fout opgetreden tijdens uw aanvraag. Probeer het <a href="https://autoverkooppartner.nl">opnieuw</a> of neem contact op met onze <a href="https://autoverkooppartner.nl/klantenservice/">klantenservice</a>.</p>
              </div>
            }
            @case ('response-false') {
              <div>
                <p class="lead">De door jouw gebruikte link is niet (meer) geldig. <br>
                Start een nieuwe aanvraag.</p>
                <button type="button" (click)="returnHome()" class="btn btn-primary">Opnieuw beginnen</button>
              </div>
            }
            @case ('response-error') {
              <div>
                <p class="lead">Er is een fout opgetreden tijdens het ophalen van voertuiggegevens.</p>
              </div>
            }
            @case ('no-permission') {
              <div>
                <p class="lead">Je hebt geen toegang tot deze pagina.</p>
              </div>
            }
            @case ('not-allowed') {
              <div>
                <p class="lead">Deze taxatie is al geaccepteerd.</p>
              </div>
            }
          }
        </div>

        <div style="height: 900px"></div>
      </div>
    </div>
  </div>
